import './stylex.scss'

const Tag = ({ text, size = 'M' }) => {
    return (
        <div className={`tag tag--${size}`}>{text}</div>
    );
}

export default Tag;